import { resolveLayoutName } from "./layout"
import { resolveThemeColorMode, resolveThemeTokens } from "./theme"
import type { ResolvedStorefrontConfig, StoreConfig } from "./types"

/**
 * Narrows the storefront-owned fields of a raw tenant StoreConfig (the fields the
 * backend does not guarantee) to safe, complete values:
 *   - `layout` is validated against the LayoutName union, falling back to default.
 *   - `theme` tokens are completed from the default theme (token completeness).
 *   - `theme.colorMode` is narrowed to the ThemeColorMode union (unknown → both).
 *
 * The rest of StoreConfig is trusted as-is (it derives from the storefront-api
 * contract). This is the only zod-guarded seam in packages/model.
 */
export function resolveStorefrontConfig(
  config: Pick<StoreConfig, "layout" | "theme">
): ResolvedStorefrontConfig {
  return {
    layout: resolveLayoutName(config.layout),
    theme: resolveThemeTokens(config.theme),
    colorMode: resolveThemeColorMode(config.theme),
  }
}
